import { Model } from '../model';

export class MessageTypeLabels extends Model {
  id: string;
  label: string;
}

export class SuperAccountSettings extends Model {
  buttonColor: string;
  disablePasswordChange: boolean;
  domain: string;
  headerColor: string;
  messageTypeLabels: MessageTypeLabels[] | null;
  shopEnabled: boolean;
  shopUrl: string;
  showSubSettings: boolean;
  titleColor: string;
  logoBase64: string;
}

export class AccountsSmsAvailability extends Model {
  superAccount: Array<SmsAvailability>;
  subAccount: Array<SmsAvailability>;
}

export class SmsAvailability extends Model {
  messageType: string;
  availability: number;
  idNation?: string;
}
